export const selectAllText = (id: string) => {
  const parent = document.getElementById(id);
  if (!parent) return;

  window && window?.getSelection()?.selectAllChildren(parent);
};
